var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"resize-none",attrs:{"cols":"1","rows":"1"},domProps:{"value":_vm.value},on:{"input":_vm.typing}})
}
var staticRenderFns = []

export { render, staticRenderFns }